import PageBanner from './PageBanner.vue';

PageBanner.install = (Vue) => {
  Vue.component(PageBanner.name, PageBanner);
};

export default PageBanner;
